import React, { useRef } from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import moment from "moment";
import TableSkeleton from "../../common/components/TableSkeleton";

const EventCalendar = ({
  events,
  loading,
  setCalendarDateRange,
  customBtn,
}) => {
  // Ref to access FullCalendar API
  const calendarRef = useRef(null);
  // Function to handle the "prev" button action
  const handlePrev = () => {
    const calendarApi = calendarRef.current?.getApi(); // Access the FullCalendar API
    if (calendarApi) {
      calendarApi.prev(); // Perform the default "prev" action

      const currentDate = calendarApi.getDate(); // Get the new current date
      updateCalendarDateRange(currentDate);
    }
  };

  // Function to handle the "next" button action
  const handleNext = () => {
    const calendarApi = calendarRef.current?.getApi(); // Access the FullCalendar API
    if (calendarApi) {
      calendarApi.next(); // Perform the default "next" action

      const currentDate = calendarApi.getDate(); // Get the new current date
      updateCalendarDateRange(currentDate);
    }
  };

  // Function to update the calendar date range
  const updateCalendarDateRange = (currentDate) => {
    const startDate = moment(currentDate).startOf("month");
    const endDate = moment(currentDate).endOf("month");

    setCalendarDateRange((pre) => ({
      startDate,
      endDate,
      prev: !!pre.startDate
        ? {
            startDate: pre.startDate,
            endDate: pre.endDate,
          }
        : null,
    }));
  };

  const handleEventClick = (action) => {
    // Extracting event details and displaying them
    const { title, start, end, extendedProps } = action.event;

    const startDate = start.toLocaleDateString();
    const endDate = end ? ` to ${end.toLocaleDateString()}` : "";
    alert(`Event: ${title}\nStart: ${startDate}${endDate}`);
    // You can replace this alert with a modal or custom display logic
  };

  // if (loading)
  //   return (
  //     <table className="w-100">
  //       <thead>
  //         <tr>
  //           <th>Sun</th>
  //           <th>Mon</th>
  //           <th>Tue</th>
  //           <th>Wed</th>
  //           <th>Thu</th>
  //           <th>Fri</th>
  //           <th>Sat</th>
  //         </tr>
  //       </thead>
  //       <TableSkeleton rows={6} cols={7} />
  //     </table>
  //   );

  return (
    <FullCalendar
      ref={calendarRef}
      plugins={[dayGridPlugin, interactionPlugin]}
      initialView="dayGridMonth"
      headerToolbar={{
        left: "prev,next",
        center: "title",
        right: `dayGridDay,dayGridWeek,dayGridMonth${
          customBtn ? " customBtn" : ""
        }`, // user can switch between the two
      }}
      selectable={true}
      selectMirror={true}
      dayMaxEvents={true}
      events={!loading ? events : []}
      eventContent={(eventInfo) => {
        // console.log({ eventInfo });

        return (
          <div className="mb-2">
            <i>{eventInfo.event.title}</i>
          </div>
        );
      }}
      eventClick={handleEventClick}
      customButtons={{
        prev: {
          text: "Prev",
          click: handlePrev,
        },
        next: {
          text: "Next",
          click: handleNext,
        },
        customBtn: customBtn,
      }}
    />
  );
};

export default EventCalendar;
